import request from '@/utils/request'
import { Device } from "@hybird/device";
import {EquipmentRecBeginSealInterceptor} from "@hybird/device/interceptor/beginSeal/equipmentRecBeginSeal";
import { BleV2DeviceProtocolBeginSeal} from "@hybird/device/protocol/blev2";
function createAdapter(keyMap = {}) {
    return (json) => {
        const model = {};
        Object.entries(json || {}).forEach(([key, value]) => {
            const modelKey = keyMap[key] || key;
            model[modelKey] = value;
        });
        return model;
    };
}

const createMapper = (map, defaultValue = "未知") => 
  (code) => map[code] ?? defaultValue

///todo:

export const deviceMapper = createMapper({
  1: "天玺",
  2: "金盾",
  3: "手机",
  4: "印控仪",
  5: "APP",
  6: "小程序",
  7: "H5",
  8: "军工",
})

export const tagMapper = createMapper({
  1: "用印环境",
  2: "用印前拍照",
  3: "远程确认",
  4: "盖印抓拍",
  5: "补盖抓拍",
  6: "手动补拍",
  7: "单次",
  8: "全段",
  9: "风险",
  10: "强制补拍",
})

export const imgVideoAdapter = createAdapter({imgVideo1:'imgVideo'})
export const bnaAdapter = createAdapter({before1:'before',now1:'now',after1:'after'})
export const ivAdapter = createAdapter({img:'img',video:'video'})

export const mediaItemAdapter = createAdapter({turn:'turn',busiTag:'tag',source:'device',fullFile:'fullFile',staffName:'staffName','sealTime':'time',address:'address',deviceType:'deviceType',pictureType:'pictureType',photoType:'photoType',brightType:'brightType'})





 const yyApi = {
  documentLoginId: '',
  key: new Date().getTime(),
  noYYLeftTimes:[],

  documentLogin : () => {
  return request({
    url: `/common/document/login`,
    method: 'GET',
  })
},

  getDocumentLoginId() {
    console.table('getDocumentLoginId',new Date().getTime(),this)
    return this.documentLoginId;
  },

  rmDocumentLoginId() {
    console.table('rmDocumentLoginId',new Date().getTime())
    this.documentLoginId = ''
    EquipmentRecBeginSealInterceptor.operationId = this.documentLoginId
    BleV2DeviceProtocolBeginSeal.operationId = this.documentLoginId
  },

  leftTimes(number,sealId) {
    let deviceProtocol = Device.getByNumber(number)?.deviceProtocol
    let deviceInfo = deviceProtocol?.deviceInfo
    let r = deviceInfo?.leftTimes
    if(r==null&&sealId!=null){
      for (let index = 0; index < this.noYYLeftTimes.length; index++) {
        const element = this.noYYLeftTimes[index];
        if (element.sealId==sealId) {
          return element.applicationNumber-element.practicalNumber
        }
      }
    }
    return r
  },

  setDocumentLoginId() {
    if (this.documentLoginId) {
      return
    }
    return new Promise(async (resolve, reject) => {
      var res = await this.documentLogin()
      if (res.code == 0) {
        this.documentLoginId = res.data
        EquipmentRecBeginSealInterceptor.operationId = this.documentLoginId
        BleV2DeviceProtocolBeginSeal.operationId = this.documentLoginId
      }
      console.table('setDocumentLoginId',new Date().getTime(),this)
      resolve()
    });
  }
};
export {yyApi};


export const  isNewImgVideo = (d) => {
  const time = '2025/08/13 00:00:00';
  if (d === null || d === undefined) {
    return true;
  }

  const r = new Date(d.replace(/-/g,'/'));
  if (isNaN(r.getTime())) {
    return true;
  }

  const targetDate = new Date(time);

  return r.getTime() > targetDate.getTime();
}

